import React from 'react';
import cn from 'classnames';
import { URLS } from '@wix/da-url';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import CoreSymbol from '@wix/da-ds/pkg/Indicators/CoreSymbol';

import s from './CoreUpsellNote.scss';

interface Props {
  label: string;
  ctaLabel: string;
  className?: string;
}

const CoreUpsellNote: React.FC<Props> = ({ label, ctaLabel, className }) => {
  return (
    <div className={cn(s['core-upsell'], className)}>
      <div className={s['core-upsell-text']}>{label}</div>
      <TextButton
        className={s['core-cta']}
        size="small"
        variant="main"
        href={URLS.CORE_MEMBERSHIP}
        icon={CoreSymbol}
      >
        {ctaLabel}
      </TextButton>
    </div>
  );
};
CoreUpsellNote.displayName = 'CoreUpsellNote';

export default CoreUpsellNote;
